import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { withEllipsis } from "@styles/common-styles";
import { UiUtils } from "@stellar/utils";
import { useMemo } from "react";

/**
 * Component that renders the name of the file associated to the background task.
 * If there is no file name available then it shows the task type.
 */
export function BackgroundTaskFileName(t0) {
  const $ = _c(6);
  const {
    task
  } = t0;
  const isFileNameAvailable = task.elementName && task.elementName.length > 0;
  const text = isFileNameAvailable ? task.elementName : task.taskType ?? UiUtils.DASH;
  const t1 = isFileNameAvailable ? "bold" : "inherit";
  const t2 = isFileNameAvailable ? "inherit" : "text.disabled";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      fontWeight: t1,
      color: t2,
      ...withEllipsis
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3 || $[4] !== text) {
    t4 = <Box component="var" sx={t3}>{text}</Box>;
    $[3] = t3;
    $[4] = text;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}